/** Inset image edge — pure black/white, never a tinted neutral. */
export const PUBLIC_IMAGE_OUTLINE =
  'outline outline-1 -outline-offset-1 outline-black/10 dark:outline-white/10'

/** Banner frame on public org/profile heroes. */
export const PUBLIC_BANNER_SURFACE =
  'relative overflow-hidden rounded-xl bg-muted/40 shadow-[var(--shadow-border)]'

/** Read-only public cards (experience, apply aside, empty states). */
export const PUBLIC_CARD_SURFACE = 'border-0 shadow-[var(--shadow-border)]'

/** Clickable public cards (open role rows). */
export const PUBLIC_CARD_SURFACE_INTERACTIVE =
  'border-0 shadow-[var(--shadow-border)] transition-[box-shadow,background-color] duration-150 ease-out hover:shadow-[var(--shadow-border-hover)] hover:bg-muted/40'
